import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ClientInterface } from '@shared/api';
import { environment } from '@shared/environments';
import { Observable, tap } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientsService extends CustomEntityCollectionBaseService<ClientInterface> {
  private readonly http = inject(HttpClient);

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.Client, elementsFactory);
  }

  registerClients(guids: string[]): Observable<unknown> {
    return this.http
      .post(`${environment.apiHost}/clients/register`, {
        clientGuids: guids,
      })
      .pipe(tap(() => this.refresh()));
  }

  unregisterClients(guids: string[]): Observable<unknown> {
    return this.http
      .post(`${environment.apiHost}/clients/unregister`, {
        clientGuids: guids,
      })
      .pipe(tap(() => this.refresh()));
  }

  blockClients(guids: string[]): Observable<unknown> {
    return this.http
      .post(`${environment.apiHost}/clients/block`, {
        clientGuids: guids,
      })
      .pipe(tap(() => this.refresh()));
  }

  unblockClients(guids: string[]): Observable<unknown> {
    return this.http
      .post(`${environment.apiHost}/clients/unblock`, {
        clientGuids: guids,
      })
      .pipe(tap(() => this.refresh()));
  }

  renameClients(guid: string, clientName: string): Observable<unknown> {
    return this.http
      .post(`${environment.apiHost}/clients/${guid}/rename`, {
        name: clientName,
      })
      .pipe(tap(() => this.refresh()));
  }
}
